import { useQuery } from '@tanstack/react-query';
import { client } from '@/services/api/axios.ts';
import { DEVICE_TYPE_OPTIONS } from '@/features/devices/schemas/devices.schemas.ts';

const DEVICE_TYPES_STALE_TIME = 1000 * 60 * 60 * 24;

export const deviceTypeKeys = {
  all: ['device-types'] as const,
};

export const useDeviceTypesQuery = () => {
  return useQuery({
    queryKey: deviceTypeKeys.all,
    queryFn: async () => {
      const { data } = await client.get<{ body: (typeof DEVICE_TYPE_OPTIONS)[number][] }>(
        '/services/device-types'
      );
      return data.body;
    },
    staleTime: DEVICE_TYPES_STALE_TIME,
    gcTime: DEVICE_TYPES_STALE_TIME,
  });
};
